import { createBrowserRouter, Navigate } from "react-router-dom";
import AuthLayout from "../layouts/partner/AuthLayout/AuthLayout";
import LoginCard from "../components/LoginCard/LoginCard";
import FirstTimeLoginLayout from "../layouts/partner/FirstTimeLoginLayout/FirstTimeLoginLayout";
import Page1 from "../pages/partner/WelcomePages/Page1";
import Page2 from "../pages/partner/WelcomePages/Page2";
import Page3 from "../pages/partner/WelcomePages/Page3";
import ExperienceForm from "../pages/partner/DashboardForms/ExperienceForm/ExperienceForm";
import ProfileDetailsForm from "../pages/partner/DashboardForms/ProfileDetailsForm/ProfileDetailsForm";
import DashboardLayout from "../layouts/partner/DashboardLayout/DashboardLayout";
import Dashboard from "../pages/partner/DashboardPages/Dashboard/Dashboard";
import CallbackPage from "../pages/partner/DashboardPages/Callback/Callback";
import PostRequirement from "../pages/partner/DashboardForms/PostRequirement/PostRequirement";
import DashboardSectionLayout from "../layouts/partner/DashboardSectionLayout/DashboardSectionLayout";
import Equipments from "../pages/partner/DashboardPages/Eqipments/Equipments";
import EquipmentDetails from "../pages/partner/DashboardPages/Eqipments/EquipmentDetails";
import Services from "../pages/partner/DashboardPages/Services/Services";
import Licenses from "../pages/partner/DashboardPages/Licenses/Licenses";
import LicenseDetails from "../pages/partner/DashboardPages/Licenses/LicenseDetails";
import KycDocuments from "../pages/partner/DashboardPages/KycDocuments/KycDocuments";
import Certificates from "../pages/partner/DashboardPages/Certificates/Certificates";
import CertificateDetails from "../pages/partner/DashboardPages/Certificates/CertificateDetails";
import EquipmentsForm from "../pages/partner/DashboardForms/EquipmentsForm/EquipmentsForm";
import ServiceForm from "../pages/partner/DashboardForms/ServiceForm/ServiceForm";
import ServiceDetails from "../pages/partner/DashboardPages/Services/ServiceDetails";
import LicensesForm from "../pages/partner/DashboardForms/LicensesForm/LicensesForm";
import LicenseEditForm from "../pages/partner/DashboardForms/LicensesForm/LicensesEditForm";
import KycDocumentsForm from "../pages/partner/DashboardForms/KycDocumentsForm/KycDocumentsForm";
import PartnerEditProfile from "../pages/partner/DashboardForms/PartnerForm/PartnerEditProfile";
import CertificateForm from "../pages/partner/DashboardForms/CertificateForm/CertificateForm";
import CertificateEditForm from "../pages/partner/DashboardForms/CertificateForm/CertificateEditForm";
import SocialForm from "../pages/partner/DashboardForms/SocialForm/SocialForm";
import TrainingPrograms from "../pages/partner/DashboardPages/TrainingPrograms/TrainingPrograms";
import Kyc from "../pages/partner/DashboardPages/Kyc/Kyc";
import Profile from "../pages/partner/DashboardPages/Profile/Profile";
import ProfessionalInfoForm from "../pages/partner/DashboardForms/ProfessionalInfoForm/ProfessionalInfoForm";
import ProfessionalSkills from "../pages/partner/DashboardForms/ProfessionalSkills/ProfessionalSkills";
import CountryShots from "../components/AerialBorneShorts/CountryShots/CountryShots";
import FeedbackForm from "../components/FeedbackForm/FeedbackForm";
import ClientRecommendationForm from "../pages/partner/DashboardForms/Review/ClientRecommendationForm";
import AddYourServices from "../components/AddYourServices/AddYourServices";
import HowWeWork from "../components/HowWeWork/HowWeWork";
import ContactForm from "../pages/partner/DashboardForms/ContactForm/ContactForm";
import About from "../components/About/About";
import PolicyPage from "../components/PrivacyPolicy/PolicyPage";
import PrivacyPolicy from "../components/AerialBorneShorts/CountryShots/PrivacyPolicy";
import FooterPrivacy from "../components/FooterPrivacy/FooterPrivacy";
import TermCondition from "../components/Term&Condition/Term&Condition";
import CommunityGuidelines from "../components/CommunityGuidelines/CommunityGuidelines";
import Refund from "../components/Refund/Refund";
import KycDocumentDetail from "../pages/partner/DashboardPages/KycDocuments/KycDocumentDetail";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AuthLayout />,
    children: [
      {
        index: true,
        element: <LoginCard />,
      },
    ],
  },
  {
    path: "/welcome",
    element: <FirstTimeLoginLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="1" replace="true" />,
      },
      {
        path: "1",
        element: <Page1 />,
      },
      {
        path: "2",
        element: <Page2 />,
      },
      {
        path: "3",
        element: <Page3 />,
      },
      {
        path: "profile-details",
        element: <ProfileDetailsForm />,
      },
      {
        path: "professional-details",
        element: <ProfessionalInfoForm />,
      },
      {
        path: "add-skills",
        element: <ProfessionalSkills />,
      },
    ],
  },
  {
    path: "/dashboard",
    element: <DashboardLayout />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },

      {
        path: "",
        element: <DashboardSectionLayout />,
        children: [
          {
            path: "post-requirement",
            element: <PostRequirement />,
          },
          {
            path: "equipments",
            children: [
              {
                index: true,
                element: <Equipments />,
              },
              {
                path: "add-equipments",
                element: <EquipmentsForm />,
              },
              {
                path: ":equipmentId",
                element: <EquipmentDetails />,
              },
            ],
          },
          {
            path: "services",
            children: [
              {
                index: true,
                element: <Services />,
              },
              {
                path: "add-services",
                element: <ServiceForm />,
              },
              {
                path: ":serviceId",
                element: <ServiceDetails />,
              },
            ],
          },
          {
            path: "callback",
            element: <CallbackPage />,
          },

          {
            path: "certificates",
            children: [
              { index: true, element: <Certificates /> },
              { path: "add-certificate", element: <CertificateForm /> },
              {
                path: "edit-certificate/:certificateId",
                element: <CertificateEditForm />,
              },
              {
                path: ":certificateId",
                element: <CertificateDetails />,
              },
            ],
          },
          {
            path: "licenses",
            children: [
              { index: true, element: <Licenses /> },
              {
                path: "add-license",
                element: <LicensesForm />,
              },
              {
                path: "edit-licence/:licenceId",
                element: <LicenseEditForm />,
              },
              {
                path: ":licenceId",
                element: <LicenseDetails />,
              },
            ],
          },
          {
            path: "social",
            element: <SocialForm />,
          },

          {
            path: "kycdocuments",
            children: [
              { index: true, element: <KycDocuments /> },
              { path: "add-kycdocument", element: <KycDocumentsForm /> },
              {
                path: ":kycId",
                element: <KycDocumentDetail />,
              },
            ],
          },
          {
            path: "partner",
            children: [
              {
                index: true,
                element: <Profile />,
              },
              {
                path: "edit-profile",
                element: <ProfileDetailsForm />,
              },
              {
                path: "experience-form",
                element: <ExperienceForm />,
              },
            ],
          },
          {
            path: "training-programs",
            children: [
              {
                index: true,
                element: <TrainingPrograms />,
              },
            ],
          },
          {
            path: "kyc",
            element: <Kyc />,
          },
          {
            path: "review",
            element: <ClientRecommendationForm />,
          },
          {
            path: "add-your-services",
            element: <AddYourServices />,
          },

          {
            path: "country-shots/:index/:idx",
            element: <CountryShots />,
          },
          {
            path: "country-shots/:index/:idx/privacy-policy",
            element: <PrivacyPolicy />,
          },
          {
            path: "how-we-work",
            element: <HowWeWork />,
          },
          {
            path: "contact-us",
            element: <ContactForm />,
          },
          {
            path: "privacy-policy",
            element: <FooterPrivacy />,
          },
          {
            path: "terms&Conditions",
            element: <TermCondition />,
          },
          {
            path: "community-guidelines",
            element: <CommunityGuidelines />,
          },
          {
            path: "refunds",
            element: <Refund />,
          },
          {
            path: "about-us",
            element: <About />,
          },
        ],
      },
    ],
  },
]);
